import { chartFields } from "./costBreakdownChart";

const fakeCostBreakdown = (kind, name = null) => {
  // Faked data
  const costs = chartFields(kind).reduce((acc, field) => {
    acc[field] = Math.random() * 3;
    return acc;
  }, { name });

  return summariesFor(kind, costs);
};

const summariesFor = (kind, costs) => {
  switch (kind) {
    case "part":
      // Shoud be already calculated
      costs.material_costs_part =
        costs.direct_material_costs_part +
        costs.material_overhead_costs_part +
        costs.interest_costs_on_material_stock_part +
        costs.material_scrap_costs_part;
      costs.manufacturing_costs_part =
        costs.work_system_costs_part +
        costs.labour_costs_part +
        costs.setup_costs_part +
        costs.tool_and_fixture_costs_part +
        costs.residual_manufacturing_overhead_costs_part +
        costs.interest_costs_of_circulating_stocks_part +
        costs.manufacturing_scrap_costs_part;
      costs.production_costs_part =
        costs.material_costs_part + costs.manufacturing_costs_part;
      costs.net_sales_price_part =
        costs.production_costs_part +
        costs.surcharges_part +
        costs.profit_part +
        costs.discount_part +
        costs.transport_costs_part +
        costs.customs_dutyies_part;
      break;
    case "manufacturingStep":
      costs.manufacturing_costs_manufacturing_step_part =
        costs.work_system_costs_manufacturing_step_part +
        costs.labour_costs_manufacturing_step_part +
        costs.setup_costs_manufacturing_step_part +
        costs.tool_and_fixture_costs_manufacturing_step_part +
        costs.residual_manufacturing_overhead_costs_manufacturing_step_part +
        costs.interest_costs_of_circulating_stocks_manufacturing_step_part +
        costs.manufacturing_scrap_costs_manufacturing_step_part;
  }
  return costs;
};

export default fakeCostBreakdown;
